type Submit = (event: Record<string, any>) => void;

class SubmittableFragmentContext {

  private listeners: Set<Submit> = new Set();

  addListener(listener: Submit): Function {
    if (this.listeners.has(listener)) {
      throw new Error('[SubmittableFragmentContext]: listener already registered.');
    }

    this.listeners.add(listener);

    return () => {
      this.listeners.delete(listener);
    };
  }

  submit(event: Record<string, any>): void {
    this.listeners.forEach(fn => fn(event));
  }

}

export default SubmittableFragmentContext;
